/**
 * 动态快捷短语，直接调用app里的shortcut就好了
 */
export default function shortcuts(data) {
  // console.log(data);
  this.shortcuts.push(data);
  return {
    // 插件返回的结果
    body: null,
  };
}



// WEBPACK FOOTER //
// ./src/app/extension/shortcuts/index.js